[
    {
      "Abbreviation": "AL",
      "Name": "Alabama",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "AK",
      "Name": "Alaska",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "AZ",
      "Name": "Arizona",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "AR",
      "Name": "Arkansas",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "CA",
      "Name": "California",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "CO",
      "Name": "Colorado",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "CT",
      "Name": "Connecticut",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "DE",
      "Name": "Delaware",
      "Channels": ["bl"]
    },
    {
      "Abbreviation": "DC",
      "Name": "Dist. of Columbia",
      "Channels": ["bl"]
    },
    {
      "Abbreviation": "FL",
      "Name": "Florida",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "GA",
      "Name": "Georgia",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "HI",
      "Name": "Hawaii",
      "Channels": []
    },
    {
      "Abbreviation": "ID",
      "Name": "Idaho",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "IL",
      "Name": "Illinois",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "IN",
      "Name": "Indiana",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "IA",
      "Name": "Iowa",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "KS",
      "Name": "Kansas",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "KY",
      "Name": "Kentucky",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "LA",
      "Name": "Louisiana",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "ME",
      "Name": "Maine",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MD",
      "Name": "Maryland",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MA",
      "Name": "Massachusetts",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MI",
      "Name": "Michigan",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MN",
      "Name": "Minnesota",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MS",
      "Name": "Mississippi",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MO",
      "Name": "Missouri",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "MT",
      "Name": "Montana",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NE",
      "Name": "Nebraska",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NV",
      "Name": "Nevada",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NH",
      "Name": "New Hampshire",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NJ",
      "Name": "New Jersey",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NM",
      "Name": "New Mexico",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NY",
      "Name": "New York",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "NC",
      "Name": "North Carolina",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "ND",
      "Name": "North Dakota",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "OH",
      "Name": "Ohio",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "OK",
      "Name": "Oklahoma",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "OR",
      "Name": "Oregon",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "PA",
      "Name": "Pennsylvania",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "RI",
      "Name": "Rhode Island",
      "Channels": ["bl", "pl"]
    },
    {
      "Abbreviation": "SC",
      "Name": "South Carolina",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "SD",
      "Name": "South Dakota",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "TN",
      "Name": "Tennessee",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "TX",
      "Name": "Texas",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "UT",
      "Name": "Utah",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "VT",
      "Name": "Vermont",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "VA",
      "Name": "Virginia",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "WA",
      "Name": "Washington",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "WV",
      "Name": "West Virginia",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "WI",
      "Name": "Wisconsin",
      "Channels": ["pl","bl"]
    },
    {
      "Abbreviation": "WY",
      "Name": "Wyoming",
      "Channels": ["pl","bl"]
    }
  ]